// Utility function to replace setTimeout with Promise-based delay
export const delay = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};